/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import React, { useState } from 'react'
import {
  Box,
  Typography
} from '@mui/material'
import { useAuth } from 'react-oidc-context'
import { connect, type ConnectedProps } from 'react-redux'
import { type RootState } from '../../../store'
import { type UploadFileInfoState } from '../redux/deviceInfoSlice'
import Modal from '@mui/material/Modal'
import LinearProgress from '@mui/material/LinearProgress'
import CloseFullscreenIcon from '@mui/icons-material/CloseFullscreen'
import OpenInFullIcon from '@mui/icons-material/OpenInFull'
import WarningIcon from '@mui/icons-material/WarningAmber'
import TaskAltIcon from '@mui/icons-material/TaskAlt'
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined'
import CloseIcon from '@mui/icons-material/Close'
import { uploadFile, resetUpload } from '../redux/actionCreators'
import { useSelector } from 'react-redux'
import LanguageStrings from '../../../i18n/locales'
import ShowDetailsComponent from '../../device-provisioning/components/ShowAssetDetails'
import { isValidName } from '../../../utils/validator'
import { GenXDropdown } from '../../../components/GenXDropdown'
import Radio from '@mui/material/Radio'
import { Grid } from '@scuf/common'
import { fetchAssetTypes } from '../../asset-configuration/redux/actionCreator'
import { type AssetTypesState } from '../../asset-configuration/redux/assetTypeSlice'

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 700,
  minHeight: 630,
  display: 'flex',
  justifyContent: 'center',
  bgcolor: '#302e2e',
  border: '1px #302e2e',
  boxShadow: '5px 5px 5px 5px #141111',
  p: 4,
  pl: '7%',
  pr: '7%',
  borderRadius: '6px'
}
const styleMinimize = {
  position: 'absolute',
  bottom: '97px',
  right: '32px',
  width: 461,
  height: 95,
  bgcolor: '#302e2e',
  p: 4,
  pl: '24px',
  pr: '25px',
  pt: '0%',
  boxShadow: '15px 30px 40px rgba(0, 0, 0, 0.4), 0px 11px 15px -2px rgba(0, 0, 0, 0.25)',
  borderRadius: '10px'
}

const UploadFileComponent = (props: Props): any => {
  const [showProgressBar, setShowProgressBar] = React.useState(false)
  const [minimized, setMinimized] = useState(false)
  const [showDetailsModal, setShowDetailsModal] = useState(false)
  const [file, setFile] = React.useState<File | null>(null)
  const uploadFileResponse = useSelector((state: any) => state.deviceInfo)
  const UploadFileStrings = LanguageStrings().UploadFileStrings
  const auth = useAuth()
  const [radioSelection, setRadRadioSelection] = useState('import')
  const [updateOptionStatus, setUpdateOptionStatus] = useState<string>('null')
  const [dataOption, setDataOption] = useState('add')
  const [category, setCategory] = React.useState<Option | null>(null)
  const [assetType, setAssetType] = React.useState<Option | null>(null)
  const [categoryOptions, setCategoryOptions] = React.useState<Option[]>([])
  const [assetTypeOptions, setAssetTypeOptions] = React.useState<Option[]>([])

  React.useEffect(() => {
    props.open && props.fetchAssetTypes()
  }, [props.open])

  React.useEffect(() => {
    if (props.assetTypes.assetTypes !== null && props.assetTypes.assetTypes.length > 0) {
      const categories: Option[] = []
      const uniqueCategories: Record<string, boolean> = {}

      props.assetTypes.assetTypes.forEach((assetType) => {
        if (!uniqueCategories[assetType.category_type_id]) {
          uniqueCategories[assetType.category_type_id] = true
          categories.push({
            value: assetType.category_type_id,
            label: assetType.category_type_name
          })
        }
      })

      setCategoryOptions(categories)
    }
  }, [props.assetTypes.assetTypes])

  const handleRadioChange = (event: { target: { value: React.SetStateAction<string> } }) => {
    const value = event.target.value
    setRadRadioSelection(value)
    if (value === 'import') {
      setUpdateOptionStatus('null')
      setDataOption('add')
    } else {
      setUpdateOptionStatus('false')
    }
  }

  const handleDataOptionChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value
    // Conditionally set true/false based on secondary selection
    setDataOption(value)
    if (value === 'replace') {
      setUpdateOptionStatus('true')
    } else if (value === 'add') {
      setUpdateOptionStatus('false')
    }
  }

  interface Option {
    label: string
    value: string
  }

  const isFileSizeLessThan10MB = (fileSize: number): boolean => {
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    const maxSize = window._env_?.REACT_APP_MAX_FILE_SIZE !== undefined ? Number(window._env_.REACT_APP_MAX_FILE_SIZE) : 10
    return fileSize > 0 && (fileSize / (1024 * 1024)) < maxSize
  }
  const isValidFileUploaded = (file: any): boolean => {
    const validExtensions = ['xml']
    const fileExtension = file.type.split('/')[1]
    return validExtensions.includes(fileExtension)
  }
  React.useEffect(() => {
    if (uploadFileResponse.errorMessage !== null || uploadFileResponse.message !== null) {
      setShowProgressBar(false)
    }
  }, [uploadFileResponse])
  const handleSubmit = (): void => {
    if (file !== null && isFileSizeLessThan10MB(file.size) && isValidFileUploaded(file) && isValidName(file.name) && file.name.length < 51 && category !== null && assetType !== null) {
      props.uploadFile(file, auth.user?.profile.name as string, auth.user?.profile.customer as string, category.label, assetType.label, updateOptionStatus)
      setShowProgressBar(true)
    }
  }
  const [progress, setProgress] = React.useState(0)

  const onFileChange = (e: any): void => {
    props.resetUpload()
    setFile(e.target.files[0])
  }

  React.useEffect(() => {
    if (uploadFileResponse.isLoading === true) {
      const timer = setInterval(() => {
        setProgress((oldProgress) => {
          if (oldProgress === 100) {
            return 0
          }
          const diff = Math.random() * 10
          return Math.min(oldProgress + diff, 100)
        })
      }, 50)
      return () => {
        clearInterval(timer)
      }
    }
  }, [uploadFileResponse])

  const onCloseModal = () => {
    setMinimized(false)
    onRemoveSelectedFile()
    props.resetUpload()
    props.handleClose()
    setCategory(null)
    setAssetType(null)
    setFile(null)
  }
  const toggleMinimize = () => {
    setMinimized(!minimized)
  }
  const onRemoveSelectedFile = () => {
    setFile(null)
    setShowProgressBar(false)
    props.resetUpload()
  }
  const retryUpload = () => {
    setShowProgressBar(true)
    props.resetUpload()
    if (file !== null && category !== null && assetType !== null) {
      props.uploadFile(file, auth.user?.profile.name as string, auth.user?.profile.customer as string, category.label, assetType.label, updateOptionStatus)
    }
  }
  const handleCloseModal = () => {
    setShowDetailsModal(false)
    setFile(null)
    props.resetUpload()
    props.handleClose()
    setCategory(null)
    setAssetType(null)
  }
  const handleDrag = function (e: any) {
    e.preventDefault()
    e.stopPropagation()
  }

  const handleDrop = function (e: any) {
    e.preventDefault()
    e.stopPropagation()
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    if (e.dataTransfer?.files && e.dataTransfer?.files[0]) {
      setFile(e.dataTransfer.files[0])
    }
  }

  const handleDragOver = (e: any) => {
    const event = e as Event
    event.stopPropagation()
    event.preventDefault()
  }

  const handleChooseCategory = (selectedOption: Option | null): void => {
    if (selectedOption !== null && selectedOption !== undefined) {
      setCategory(selectedOption)
      setAssetType(null)
      setAssetTypeOptions([])
      const tempAssetTypeOptions: Option[] = []
      if (props.assetTypes.assetTypes !== null && props.assetTypes.assetTypes.length > 0) {
        props.assetTypes.assetTypes.forEach((assetType) => {
          if (assetType.category_type_id === selectedOption.value) {
            tempAssetTypeOptions.push({
              value: assetType.asset_type_id,
              label: assetType.asset_type_name
            })
          }
        })
        setAssetTypeOptions(tempAssetTypeOptions)
      }
    }
  }

  const handleChooseAssetType = (selectedOption: Option | null): void => {
    setAssetType(selectedOption)
  }

  return (
    <div className='CardBody'>
      <Modal
        className='MainModal'
        open={props.open}
        aria-label='upload-popup'
        onClose={() => { onCloseModal() }}
        aria-labelledby='modal-modal-title'
        aria-describedby='modal-modal-description'
      >
        <Box className='pop-up-modal' sx={minimized ? styleMinimize : style}>
          {minimized
            ? (
              <OpenInFullIcon
                onClick={() => { toggleMinimize() }}
                className='OpenFullscreenIcon'
                aria-label='minimize'
              />
              )
            : (
                showProgressBar && (
                <CloseFullscreenIcon
                  onClick={() => { toggleMinimize() }}
                  className='closeFullscreenIcon'
                  aria-label='minimize'
                />
                )
              )}
          <div>
              <Grid container spacing={1} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '400px' }}>
                  <div style={{ width: '50%', display: 'flex', alignItems: 'center' }}>
                      <div className="radio-box">
                          <Radio
                              name="assetAction"
                              value="import"
                              defaultChecked={true}
                              checked={radioSelection === 'import'}
                              onChange={handleRadioChange}
                              sx={{
                                '&.MuiRadio-root': {
                                  color: 'white' // Set unselected color
                                }
                              }}
                              />
                      </div>
                      <span
                          style={{
                            fontSize: '16px',
                            padding: 5,
                            // display: 'inline-block',
                            fontFamily: 'Honeywell Sans Web',
                            flex: 1,
                            wordWrap: 'break-word',
                            overflowWrap: 'break-word'
                          }}
                          >
                          {UploadFileStrings.importAssets}
                      </span>
                  </div>
                  <div style={{ width: '50%', display: 'flex', alignItems: 'center' }}>
                      <div className="radio-box">
                          <Radio
                              name="assetAction"
                              value="update"
                              checked={radioSelection === 'update'}
                              onChange={handleRadioChange}
                              sx={{
                                '&.MuiRadio-root': {
                                  color: 'white' // Set unselected color
                                }
                              }}
                              ></Radio>
                      </div>
                      <span
                              style={{
                                fontSize: '16px',
                                padding: 5,
                                // display: 'inline-block',
                                fontFamily: 'Honeywell Sans Web',
                                flex: 1,
                                wordWrap: 'break-word',
                                overflowWrap: 'break-word'
                              }}>
                              {UploadFileStrings.updateAssets}
                          </span>
                  </div>
              </Grid>
            {minimized
              ? (
                <></>
                )
              : (
                <><Box className='modal-box' onDragEnter={handleDrag} onDragOver={handleDragOver} onDrop={handleDrop}>
                  <p style={{ marginTop: '2px' }}>
                    <DescriptionOutlinedIcon
                      className='DescriptionOutlinedIcon' />
                  </p>
                  <Typography
                    data-testid='typo-text '
                    className='draganddroptext'
                    sx={{ marginTop: '65px' }}
                  >
                    {UploadFileStrings.droptitle}
                    <br />
                    {UploadFileStrings.ortext}
                  </Typography>
                  <label className='file-label' htmlFor='file-input'>
                    <input
                      type='file'
                      id='file-input'
                      className='input-file'
                      data-testid='file-input'
                      onChange={(e: any) => {
                        onFileChange(e)
                      } }
                      onClick={(event: any) => {
                        event.target.value = null
                      } }
                      multiple />
                    {UploadFileStrings.browsefile}{' '}
                  </label>
                  <Typography
                    data-testid='typo-text2 '
                    className='subtext1'
                  >
                    {UploadFileStrings.acceptext}<br />{UploadFileStrings.errormsg} {window._env_?.REACT_APP_MAX_FILE_SIZE ?? 10}{UploadFileStrings.MB}<br />
                  </Typography>
                </Box>
                <div style={{ marginTop: '10px' }}><span>{UploadFileStrings.category}<sup style={{ color: '#EE3426', left: '0.3em' }}>*</sup> </span></div>
                <GenXDropdown
                  options={categoryOptions}
                  placeholder={UploadFileStrings.SelectCategory}
                  value={category}
                  onSelect={handleChooseCategory}
                  label={''}
                  width={400}
                />
                <div style={{ marginTop: '10px' }}><span>{UploadFileStrings.assetType}<sup style={{ color: '#EE3426', left: '0.3em' }}>*</sup> </span></div>
                <GenXDropdown
                  options={assetTypeOptions}
                  placeholder={UploadFileStrings.SelectAssetType}
                  value={assetType}
                  onSelect={handleChooseAssetType}
                  label={''}
                  width={400}
                />
                </>
                )}
            {file !== null && (
              <div className={minimized ? 'upload-file-name mn' : 'upload-file-name'}>
                {file.name.length > 20
                  ? <abbr style={{ textDecoration: 'none', cursor: 'pointer' }} title={file.name}>
                      {file.name.slice(0, 20)}...{file.name.slice(-7)}
                    </abbr>
                  : file.name
                }
                {' '}
                {!minimized && (
                  <CloseIcon
                    className='upload-file-close'
                    data-testid='close-selected-file'
                    onClick={() => { onRemoveSelectedFile() }}
                  />
                )}
              </div>
            )}
            {file !== null && !isFileSizeLessThan10MB(file.size) && <div className="failure-upload-response"><WarningIcon className='error-upload-icon' /><span className='error-upload-message'> {`${UploadFileStrings.errormsg} ${window._env_?.REACT_APP_MAX_FILE_SIZE ?? 10}${UploadFileStrings.MB}`}</span></div>}
            {file !== null && !isValidFileUploaded(file) && <div className="failure-upload-response"><WarningIcon className='error-upload-icon' /><span className='error-upload-message'>{UploadFileStrings.errormsgXML}</span></div>}
            {file !== null && !isValidName(file.name) && <div className="failure-upload-response"><WarningIcon className='error-upload-icon' /><span className='error-upload-message'>{UploadFileStrings.filenameError}</span></div>}
            {file !== null && file.name.length > 51 && <div className="failure-upload-response"><WarningIcon className='error-upload-icon' /><span className='error-upload-message'>{UploadFileStrings.filenameLength}</span></div>}
            {/* spacer */}
            <div style={{ marginBottom: '10px' }}></div>
            {showProgressBar && (
              <LinearProgress
                variant='determinate'
                value={progress}
                className='linearprogressbar'
              />
            )}
              {/* Display additional radio buttons if "Update Assets" is selected */}
              {radioSelection === 'update' && (
                  <div style={{ width: '400px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', marginTop: '5px' }}>
                      <div style={{ width: '50%', display: 'flex', alignItems: 'center' }}>
                          <div className="radio-box">
                              <Radio
                                  name="dataOptionRadio"
                                  value="replace"
                                  onChange={handleDataOptionChange}
                                  checked={dataOption === 'replace'}
                                  sx={{
                                    '&.MuiRadio-root': {
                                      color: 'white' // Set unselected color
                                    }
                                  }}
                                  />
                          </div>
                          <span
                              style={{
                                fontSize: '16px',
                                padding: 5,
                                // display: 'inline-block',
                                fontFamily: 'Honeywell Sans Web',
                                flex: 1,
                                wordWrap: 'break-word',
                                overflowWrap: 'break-word'
                              }}
                              >
                          {UploadFileStrings.replaceData}
                          </span>
                      </div>
                      <div style={{ width: '50%', display: 'flex', alignItems: 'center' }}>
                          <div className="radio-box">
                              <Radio
                                  name="dataOptionRadio"
                                  value="add"
                                  onChange={handleDataOptionChange}
                                  checked={dataOption === 'add'}
                                  defaultChecked
                                  sx={{
                                    '&.MuiRadio-root': {
                                      color: 'white' // Set unselected color
                                    }
                                  }}
                                  />
                          </div>
                          <span
                                  style={{
                                    fontSize: '16px',
                                    padding: 5,
                                    // display: 'inline-block',
                                    fontFamily: 'Honeywell Sans Web',
                                    flex: 1,
                                    wordWrap: 'break-word',
                                    overflowWrap: 'break-word'
                                  }}
                                  >
                                  {UploadFileStrings.addData}
                              </span>
                      </div>
                  </div>
              )}
            {file !== null && category !== null && assetType !== null && uploadFileResponse.errorMessage !== null && <div className="failure-upload-response"><WarningIcon className='error-upload-icon' /><span className='error-upload-message'> {uploadFileResponse.errorMessage}</span>{minimized && <a className='retry-upload' aria-label='retry-min' onClick={() => { retryUpload() }}>Retry</a>}</div>} {uploadFileResponse.message !== null && <div className="success-upload-response"><TaskAltIcon className='success-upload-icon' /><span>{ UploadFileStrings.fileUploaded }</span></div>}
            {minimized
              ? (
                <></>
                )
              : (
                  uploadFileResponse.message == null && uploadFileResponse.errorMessage == null
                    ? <div className='buttonelement'>
                    <> <button
                      data-testid='cancel-btn'
                      className='Cancelbutton'
                      aria-label='CardCancelButton'
                      onClick={() => { onRemoveSelectedFile(); props.resetUpload(); props.handleClose(); setCategory(null); setAssetType(null); setFile(null) }}
                    >
                      {UploadFileStrings.Cancel}
                    </button>
                      <button
                        aria-label='CardConfirmButton'
                        onClick={() => { handleSubmit() }}
                        className={file !== null && category !== null && assetType !== null && isFileSizeLessThan10MB(file.size) && isValidFileUploaded(file) && isValidName(file.name) && file.name.length <= 51 ? 'Confirmbutton blue-bg' : 'Confirmbutton grey-bg'}
                      >
                        {UploadFileStrings.Confirm}
                      </button></>
                  </div>
                    : uploadFileResponse.message !== null
                      ? <div className='buttonelement'>
                      <button
                        className='Cancelbutton max-width device-list-button'
                        aria-label='CardCancelButton'
                        data-testid='Asset-list'
                        onClick={() => { props.resetUpload(); props.handleClose(); setCategory(null); setAssetType(null); setFile(null) }}
                      >
                      {UploadFileStrings.Cancel}
                      </button>
                      <button
                        aria-label='CardConfirmButton'
                        onClick={() => { setShowDetailsModal(true) }}
                        className={file !== null && category !== null && assetType !== null ? 'Confirmbutton blue-bg max-width' : 'Confirmbutton grey-bg max-width'}
                      >
                        {UploadFileStrings.ShowDetails}
                      </button></div>
                      : <div className='buttonelement'><button
                      className='Cancelbutton'
                      aria-label='CardCancelButton'
                      onClick={() => { props.resetUpload(); props.handleClose(); setCategory(null); setAssetType(null); setFile(null) }}
                    >
                      {UploadFileStrings.Cancel}
                    </button>
                      <button
                        aria-label='CardConfirmButton'
                        onClick={() => { retryUpload() }}
                        className={file !== null && category !== null && assetType !== null ? 'Confirmbutton blue-bg' : 'Confirmbutton grey-bg'}
                      >
                        {UploadFileStrings.Retry}
                      </button></div>)}
          </div>
        </Box>
      </Modal>
      {showDetailsModal && <Modal open={showDetailsModal} onClose={handleCloseModal} ><ShowDetailsComponent handleClose={handleCloseModal}/></Modal>}
    </div>
  )
}
const mapDispatchToProps = (dispatch: any) => ({
  uploadFile: (file: File, name: string, tenantID: string, assetCategory: string, assetType: string, updateOptionStatus: string) => dispatch(uploadFile(file, name, tenantID, assetCategory, assetType, updateOptionStatus)),
  resetUpload: () => dispatch(resetUpload()),
  fetchAssetTypes: () => dispatch(fetchAssetTypes())
})

interface StateToProps {
  deviceInfo: UploadFileInfoState
  assetTypes: AssetTypesState
}

const mapStateToProps = (state: RootState): StateToProps => ({
  deviceInfo: state.deviceInfo,
  assetTypes: state.assetTypes
})

const connector = connect(mapStateToProps, mapDispatchToProps)
type PropsFromRedux = ConnectedProps<typeof connector>
interface Props extends PropsFromRedux {
  open: boolean
  handleClose: any
}

export default connector(UploadFileComponent)
